<template>
    <div>
        <vx-card id="dataDiv" class="vs-con-loading__container" :title="template.name">

            <div class="vx-row">
                <div class="vx-col lg:w-2/3 w-full">
                    <p class="mt-6">Name</p>
                    <vs-input :disabled="editingDisabled" v-model="template['name']" class="w-full"></vs-input>
                    <p class="mt-6">Template</p>
                    <vs-input :disabled="editingDisabled" v-model="template['template']" class="w-full"></vs-input>
                    <h5 class="mt-6">Parameters</h5>
                    <div class="vx-row mb-3" :key="param.id" v-for="(param, index) in templateParams">
                        <div class="vx-col w-1/3">
                            <vs-input :disabled="true" v-model="templateParams[index]" class="w-full mt-6"></vs-input>
                        </div>
                        <div class="vx-col w-1/3">
                            <p>Name</p>
                            <vs-input :disabled="editingDisabled" v-model="paramNames[param]" class="w-full"></vs-input>
                        </div>
                        <div class="vx-col w-1/3">
                            <p>Default value</p>
                            <vs-input :disabled="editingDisabled" v-model="paramDefaults[param]" class="w-full"></vs-input>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/3 w-full">

                    <h4>Default parameters</h4>
                    <vs-divider/>

                    <h6 class="mt-3">source_url</h6>
                    <p>Channel source URL</p>

                    <h6 class="mt-3">channel_name</h6>
                    <p>Full channel name</p>

                    <h6 class="mt-3">channel_name_serialized</h6>
                    <p>Serialized channel name (lowercase alpha-numeric and _)</p>

                    <h6 class="mt-3">channel_id</h6>
                    <p>Internal channel ID</p>

                    <h6 class="mt-3">worker_channel_name</h6>
                    <p>Full worker channel name</p>

                    <h6 class="mt-3">worker_channel_name_serialized</h6>
                    <p>Serialized worker channel name (lowercase alpha-numeric and _)</p>

                    <h6 class="mt-3">worker_channel_id</h6>
                    <p>Internal worker channel ID</p>

                    <h6 class="mt-3">local_http_folder</h6>
                    <p>Local folder with HLS files</p>

                    <h6 class="mt-3">local_http_m3u8</h6>
                    <p>Local path to m3u8 file</p>

                    <h6 class="mt-3">worker_name</h6>
                    <p>Name of worker running channel</p>

                    <h6 class="mt-3">worker_id</h6>
                    <p>ID of worker running channel</p>

                    <h6 class="mt-3">remote_http_folder</h6>
                    <p>Remote path to folder with HLS files</p>

                    <h6 class="mt-3">remote_http_m3u8</h6>
                    <p>Remote path to m3u8 file</p>

                    <h6 class="mt-3">drm_signer</h6>
                    <p>DRM Signer</p>

                    <h6 class="mt-3">drm_key_server</h6>
                    <p>DRM Key server</p>

                    <h6 class="mt-3">drm_content_id</h6>
                    <p>DRM Content id (in hex)</p>

                    <h6 class="mt-3">drm_signing_key</h6>
                    <p>DRM Signing key</p>

                    <h6 class="mt-3">drm_signing_iv</h6>
                    <p>DRM Signing IV</p>

                </div>
            </div>

            <vs-divider/>
            <vs-button v-if="editingDisabled" style="float: left" color="warning" icon-pack="feather" icon="icon-unlock" class="mb-3 mr-3" @click="editingDisabled = false">Enable editing</vs-button>
            <vs-button v-if="!editingDisabled" style="float: left" color="warning" icon-pack="feather" icon="icon-lock" class="mb-3 mr-3" @click="disableEditing">Disable editing</vs-button>
            <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-save" class="mb-3 mr-3" @click="saveTemplate" :disabled="!templateInputValid" v-if="!editingDisabled">Save template</vs-button>
            <vs-button style="float: left" color="danger" icon-pack="feather" icon="icon-x" class="mb-3" @click="removeTemplate" v-if="!editingDisabled">Remove template</vs-button>
            <div style="clear: left"></div>

        </vx-card>
    </div>

</template>
<script>

    export default {

        data() {
            return {

                template: {
                    name: '',
                    template: '',
                    params: []
                },

                integratedParams: [
                    'channel_name',
                    'channel_name_serialized',
                    'channel_id',
                    'worker_channel_name',
                    'worker_channel_name_serialized',
                    'worker_channel_id',
                    'local_http_folder',
                    'local_http_m3u8',
                    'worker_name',
                    'worker_id',
                    'remote_http_folder',
                    'remote_http_m3u8',
                    'source_url',
                    'remote_worker_ip',
                    'drm_signer',
                    'drm_key_server',
                    'drm_content_id',
                    'drm_signing_key',
                    'drm_signing_iv'
                ],

                paramNames: {},
                paramDefaults: {},

                editingDisabled: true
            }
        },
        methods: {
            disableEditing() {
                this.editingDisabled = true
                this.loadData()
            },
            loadData() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/template/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    for (let i = 0; i < response.data.params.length; i++) {
                        thisIns.$set(thisIns.paramNames, response.data.params[i].key, response.data.params[i].name)
                        thisIns.$set(thisIns.paramDefaults, response.data.params[i].key, response.data.params[i].default)
                    }
                    thisIns.template = response.data
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })

                loadPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            saveTemplate() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const parameters = []

                for (let i = 0; i < this.templateParams.length; i++) {
                    parameters.push({
                        key: this.templateParams[i],
                        name: this.paramNames[this.templateParams[i]],
                        default: this.paramDefaults[this.templateParams[i]]
                    })
                }

                const addPromise = this.$http.put('/api/management/v1/template/' + this.$route.params.id, {
                    name: this.template.name,
                    template: this.template.template,
                    params: parameters
                })

                addPromise.then(function() {
                    thisIns.$printSuccess('Template saved')
                    thisIns.editingDisabled = true
                    thisIns.loadData()
                })

                addPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            removeTemplate() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.delete('/api/management/v1/template/' + this.$route.params.id)

                addPromise.then(function() {
                    thisIns.$printSuccess('Template removed')
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                    thisIns.$nextTick(() => {
                        if (thisIns.template.type === 0) {
                            thisIns.$router.push('/templates/input')
                        } else if (thisIns.template.type === 1) {
                            thisIns.$router.push('/templates/work')
                        } else {
                            thisIns.$router.push('/templates/output')
                        }
                    })
                })

                addPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            }
        },
        computed: {
            templateParams() {
                const regex = /{{\.(.*?)}}/g
                const matches = []
                let match = regex.exec(this.template.template)
                while (match != null) {
                    if (!this.integratedParams.includes(match[1])) {
                        matches.push(match[1])
                    }
                    match = regex.exec(this.template.template)
                }

                return matches
            },
            templateInputValid() {
                if (!this.template.template || this.template.template.length === 0) return false
                if (!this.template.name || this.template.name.length === 0) return false

                for (let i = 0; i < this.templateParams.length; i++) {
                    if (!this.paramNames.hasOwnProperty(this.templateParams[i]) || this.paramNames[this.templateParams[i]].length === 0) return false
                    if (!this.paramDefaults.hasOwnProperty(this.templateParams[i]) || this.paramDefaults[this.templateParams[i]].length === 0) return false
                }

                return true
            }
        },
        mounted() {
            this.loadData()
        }
    }

</script>
